import React, {createContext, useContext, ReactNode, useState} from "react";
import {setSelectedBrand} from "../../store/brandSlice";
import {resetFilter} from "../../store/filterSlice";

import {useDispatch} from "react-redux";
interface BrandContextProps {
	url: any;
	switchApi: (api: string, brand: string) => void;
}

const defaultBrandContext: BrandContextProps = {
	url:
		localStorage.getItem("selectedBrand") === "rainstorm"
			? process.env.REACT_APP_API_URL_RAINSTORM
			: localStorage.getItem("selectedBrand") === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM,
	switchApi: () => {},
};
const BrandContext = createContext<BrandContextProps>(defaultBrandContext);

interface BrandProviderProps {
	children: ReactNode;
}

export const BrandProvider: React.FC<BrandProviderProps> = ({children}) => {
	const [url, setUrl] = useState<string>(defaultBrandContext.url);
	const dispatch = useDispatch();

	const switchApi = (api: string, brand: string) => {
		dispatch(resetFilter());
		dispatch(setSelectedBrand(brand));
		setUrl(api);
	};

	return (
		<BrandContext.Provider value={{url, switchApi}}>
			{children}
		</BrandContext.Provider>
	);
};

export const useBrand = (): BrandContextProps => {
	return useContext(BrandContext);
};
